module.exports = __webpack_public_path__ + "media/images/table-sort-up-963e0271.gif";